module.exports = __webpack_public_path__ + "img/new_user_modal_bg1.192397ec.png";